var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-qrcode',{attrs:{"value":_vm.qr_code_url,"options":{
        width: _vm.width
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }